import { QRCodeSVG } from 'qrcode.react';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, QRCodeWrapper, CopyInput } from '@woovi/ui';

import type { PaymentMethodPixQrCode_charge$key } from './__generated__/PaymentMethodPixQrCode_charge.graphql.ts';
import { useChargePaymentMethod } from '../../charge/useChargePaymentMethod.tsx';

type PaymentMethodPixQrCodeProps = {
  charge: PaymentMethodPixQrCode_charge$key;
  qrCodeShow?: boolean;
  copyQRCodeError?: boolean;
  alwaysShowQrCode?: boolean;
  onError?: (error: boolean) => void;
};

const PaymentMethodPixQrCode = ({
  copyQRCodeError = false,
  alwaysShowQrCode = false,
  ...props
}: PaymentMethodPixQrCodeProps): ReactNode => {
  const charge = useFragment<PaymentMethodPixQrCode_charge$key>(
    graphql`
      fragment PaymentMethodPixQrCode_charge on Charge {
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { pix } = useChargePaymentMethod(charge);

  if (!pix.brCode) {
    return null;
  }

  const qrCodeShow = props.qrCodeShow || copyQRCodeError || alwaysShowQrCode;

  return (
    <>
      <QRCodeWrapper qrCodeShow={qrCodeShow} data-testid='qrcode'>
        <QRCodeSVG value={pix.brCode} marginSize={4} />
      </QRCodeWrapper>
      <BoxFlex
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
        }}
      >
        <CopyInput
          value={pix.brCode}
          error={copyQRCodeError}
          onError={props.onError}
        />
      </BoxFlex>
    </>
  );
};

export default PaymentMethodPixQrCode;
